export default __webpack_public_path__ + "static/media/TypeQuiz.27d6d9b7.PNG";